<template>
    <div class="panel">
        <form action="https://clinic.n-avatars.com/saveReport" id="send-to-mailer-form" method="POST" target="_BLANK">
            <input type="hidden" name="firstName" v-bind:value="$parent.$parent.params.get('firstName')">
            <input type="hidden" name="patientId" v-bind:value="$parent.$parent.params.get('patientId')">
            <input type="hidden" name="apptLocation" v-bind:value="$parent.$parent.params.get('apptLocation')">
            <input type="hidden" name="apptDate" v-bind:value="$parent.$parent.params.get('apptDate')">
            <input type="hidden" name="apptTime" v-bind:value="$parent.$parent.params.get('apptTime')">
            <input type="hidden" name="recipientEmail" v-bind:value="$parent.$parent.params.get('senderEmail')">
            <input type="hidden" name="fileName" v-bind:value="formattedFileName">
            <input type="hidden" name="fileContent" v-bind:value="formattedResponse">
            <input type="hidden" name="key" value="bbd09a50-e9d9-4067-a1e5-02050b89524f">
        </form>
        <transition nam="fade">
            <div class="row thank-you" v-if="show">
                <div class="col thank-you">
                    <img :src="require('@/assets/images/panel_graphics/conclusion.png')" alt="">
                </div>
            </div>
        </transition>
        <transition name="slide" appear>
            <div class="row download">
                <div class="col download">
                    <a href="https://chiro.n-avatars.com/docs/AVO_intake_form.pdf" target="_blank">
                        <button v-on:click="handleClick" id="download-form">Download Form</button>
                    </a>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import response from '@/stores/response.js'

    export default {
        name: 'Conclusion_panel',
        data: function () {
            return {
                selectedItem: null,
                response: response,
                formattedResponse: "",
                formattedFileName: "",
                show: false
            };
        },
        created: function () {
            this.formattedFileName = this.$parent.$parent.params.get('patientId') + "-" + this.$parent.$parent.params.get("firstName") + "-" + this.$parent.$parent.params.get("apptLocation") + "-" + this.$parent.$parent.params.get("apptDate");
            this.formattedFileName = this.formattedFileName.replace(/[^a-z0-9]/gi, '-')  + ".html";
            this.formattedResponse = this.formatResponse();
        },
        mounted: function () {
            CodeBaby.jQuery.post("https://mailer.idavatars.com/saveReport", CodeBaby.jQuery( "#send-to-mailer-form" ).serialize());
        },
        methods:{
            handleClick: function (event) {
                this.selectedItem = event.target;
                this.show = true;
                CodeBaby.jQuery('#download-form, .col.download').addClass('active');
                //window.location.href="https://chiro.n-avatars.com/docs/AVO_intake_form.pdf"
            },
            formatResponse: function() {
                var formatted=`<html><head><title> AVO Health Client Intake Report </title></head>
                <body style="margin:0px;padding:0px;background-color:white;">
                    <div class="container" style="width:100%;text-align:center;">
                        <div style="width:90%;height:auto;text-align:center;margin-right:auto;margin-left:auto;font-family:'Helvetica-Neue',Helvetica,Arial,san-serif;color:#787889;margin-top:20px;">
                            <p style="font-size:18px;font-weight:bold;">AVO Health Clinic<br>
                            Intake Information for ` + this.$parent.$parent.params.get('firstName') + `, #` + this.$parent.$parent.params.get('patientId') + `<br>
                            Appointment: ` + this.$parent.$parent.params.get('apptTime') + `, ` + this.$parent.$parent.params.get('apptDate') + `</p>
                            <p></p>
                `;



                this.response.forEach((section, index) => {
                    formatted += `<p style="font-size:16px;font-weight: bold;">` + section.question + "<br>";
                    formatted += `<span style="font-weight: normal;">`;
                    if (Array.isArray(section.answer)) {
                        
                        section.answer.forEach((value, answerIndex) => {
                            if (answerIndex != 0) formatted += ", ";
                            formatted += value;
                        });
                    }else if (section.question == "Patient ID"){
                        formatted += this.$parent.$parent.params.get('patientId');
                    }else{
                        formatted += section.answer;
                    }
                    formatted += "</span></p>";
                });
                var d = new Date();
                formatted += `
                        <p style="font-size:16px;font-weight: bold;">Online Information Completed:<br>
                          <span style="font-weight: normal;">` + d + `</span></p>
                        <p></p>
                        <p style="font-size: 12px;">
                            AVO Health<br>
                            3101 Clairmont Rd. NE, Unit A, Atlanta, Georgia 30329<br>
                            404-985-6209  <a href="mailto:info@avohealth.net" style="color: #999999;">info@avohealth.net</a>
                        </p>
                        <p></p>
                    </div>
                </div>
                </body>
                </html>`;
                return formatted;


                /*var formatted="<html><head><title>" + this.formattedFileName + "</title></head><body>";
                this.response.forEach((section, index) => {
                    formatted += "<div style='font-weight:bold'>" + section.question + "</div><div>";
                    if (Array.isArray(section.answer)) {
                        formatted += "Selected Values: ";
                        section.answer.forEach((value, answerIndex) => {
                            if (answerIndex != 0) formatted += ", ";
                            formatted += value;
                        });
                    }else if (section.question == "Patient ID"){
                        formatted += this.$parent.$parent.params.get('patientId');
                    }else{
                        formatted += section.answer;
                    }
                    formatted += "</div><div>&nbsp;</div>";
                });
                formatted += "</body></html>";
                return formatted;*/
            }
        } 

    }
</script>
<style scoped lang="stylus">
.panel
    position: relative
    text-align: center
    flex-direction: column
    .slide-enter, .slide-leave-to
        transform: translateY(-100%)
    .slide-leave-active, .slide-enter-active
        transition: 1s
    .fade-enter-active, .fade-leave-active 
        transition: opacity 1s
    .fade-enter, .fade-leave-to
        opacity: 0
.row
    display: flex
    justify-content: center
    flex: 1
    max-height: 60px
    &.thank-you
        position: relative
        top: 0
        left: 0
    .col
        position: relative
        &.download
            top: 195px
            left: 4px
            &.active
                top: 125px !important
        button
            font-size: 1.15em
            border-radius: 25px
            width: 252px
            height: 40px
            color: white
            border: 3px solid
            &#download-form
                background-color: #f49ac1
                border-color: #f49ac1
                &:hover,
                &.active
                    background-color: #bd8cbf
                    border-color: white
</style>